// src/v2/pages/Reports/BIR0619F.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useBIR0619F } from '../../hooks/useBIR0619F';
import { BIR0619FModule } from '../../components/modules/Reports/BIR0619F/BIR0619FModule';

const BIR0619F = ({ isHideSideMenu }) => {
  const reportHook = useBIR0619F();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <BIR0619FModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default BIR0619F;